import { authHeaders } from '@/utils/authToken';
import type { Referral, ReferralTier, LeaderboardEntry } from '@/types';

export const referralService = {
  async list(): Promise<Referral[]> {
    const res = await fetch('/api/referrals', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async create(data: {
    referred_name: string;
    referred_phone: string;
    referred_vehicle_category?: string;
    notes?: string;
  }): Promise<Referral> {
    const res = await fetch('/api/referrals', {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(data),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async getTiers(): Promise<ReferralTier[]> {
    const res = await fetch('/api/referral-tiers', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async getLeaderboard(): Promise<LeaderboardEntry[]> {
    const res = await fetch('/api/referral-leaderboard', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },
};
